module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_responsabilidad.30459dee.jpg";